import { FC } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../Button';

export interface DocumentViewerNavProps {
  direction: 'previous' | 'next';
  onClick: () => void;
}

export const DocumentViewerNav: FC<DocumentViewerNavProps> = ({ direction, onClick }) => {
  const { t: tFile } = useTranslation('file');
  const isPrevious = direction === 'previous';

  return (
    <IconButton
      icon={isPrevious ? 'chevronLeft' : 'chevronRight'}
      theme="text"
      diameter={48}
      className={clsx('absolute top-1/2 z-10 -translate-y-1/2 bg-darkMode-gray-dark/60', isPrevious ? 'left-4' : 'right-4')}
      aria-label={tFile(isPrevious ? 'document-viewer-previous-label' : 'document-viewer-next-label')}
      onClick={onClick}
    />
  );
};
